const BILLING_PENDING_PLAN_KEY = "billing_pending_plan";

export function setBillingPendingPlan(planId: string): void {
  sessionStorage.setItem(BILLING_PENDING_PLAN_KEY, planId);
}

export function peekBillingPendingPlan(): string | null {
  return sessionStorage.getItem(BILLING_PENDING_PLAN_KEY);
}

export function clearBillingPendingPlan(): void {
  sessionStorage.removeItem(BILLING_PENDING_PLAN_KEY);
}
